import {NgModule} from '@angular/core';
import {IonicModule} from 'ionic-angular';
import {QuillModule} from 'ngx-quill';

import {CaptionInput} from './index';

/**
 * Module for the CaptionInputModule
 * @class
 */
@NgModule({
  declarations: [CaptionInput],
  exports: [CaptionInput],
  imports: [IonicModule,
            QuillModule],
  providers: [],
})
export class CaptionInputModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/caption/caption.input.module.ts